export const LastLoginUsernameKey = 'LastLoginUsername';
export const UnauthorizedErrorKey = 'UnauthorizedErrorMessage';
export const ColorThemePreferenceKey = 'ColorThemePreference';
export const BackgroundImagePreferenceKey = 'BackgroundImagePreference';
